<app-loading-spinner *ngIf="isLoading" />


<div *ngIf="!isLoading">
    <p class="font-semibold text[#424242] mb-4 mr-5 ml-0 dark:text-[#FFFFFF] dark:bg-black">Price Update Requests</p>


    <div class="w-full min-w-0 px-4 sm:px-6 lg:px-10 py-7 bg-tileLight dark:bg-[#363636] shadow-lg rounded-lg">
        <div class="flex flex-row flex-wrap items-center justify-between gap-4 w-full">
            <div class="[@container(max-width:760px)]:basis-full flex flex-col justify-between min-w-0">
                <p class="font-semibold text-lg mb-1 dark:text-white">Price Update Requests on {{today}}</p>
            </div>
            <div class="grid flex-[1_1_30rem] grid-cols-[minmax(0,1fr)_minmax(0,1fr)_minmax(0,2fr)] items-center gap-3 min-w-0 [@container(max-width:760px)]:basis-full [@container(max-width:760px)]:grid-cols-2 [@container(max-width:480px)]:grid-cols-1">

                <div class="relative min-w-0 custom-grade-dropdown-container">
                    <!-- Hidden native select -->
                    <select [(ngModel)]="selectGrade" class="hidden" (change)="filterGrade()">
                        <option class=" dark:bg-[#292929] text-textLight dark:text-textDark hover:bg-gray-300"
                            value="A">A</option>
                        <option class=" dark:bg-[#292929] text-textLight dark:text-textDark hover:bg-gray-300"
                            value="B">B</option>
                        <option class=" dark:bg-[#292929] text-textLight dark:text-textDark hover:bg-gray-300"
                            value="C">C</option>
                    </select>

                    <!-- Custom dropdown trigger -->
                    <div class="border-[1.8px] border-[#828282] rounded-xl dark:bg-[#292929] text-textLight dark:text-textDark"
                        (click)="toggleGradeDropdown()">
                        <div class="flex flex-row justify-between items-center px-3 py-2 cursor-pointer ">
                            <span>{{ selectGrade || 'Grade' }}</span>
                            <div class="flex items-center ">
                                <!-- X icon (shown ONLY when option is selected) -->
                                <i *ngIf="selectGrade" (click)="cancelGrade($event)"
                                    class="fa-solid fa-xmark text-lg text-[#828282] mr-2 hover:text-[#555] dark:hover:text-[#aaa] cursor-pointer"></i>

                                <!-- Arrow icon (shown when EITHER: dropdown is open OR no selection exists) -->
                                <i *ngIf="isGradeDropdownOpen || !selectGrade"
                                    class="fa-solid text-lg text-[#828282] transition-transform duration-200"
                                    [class.fa-angle-down]="!isGradeDropdownOpen"
                                    [class.fa-angle-up]="isGradeDropdownOpen"></i>
                            </div>
                        </div>
                    </div>

                    <!-- Custom dropdown options -->
                    <div *ngIf="isGradeDropdownOpen"
                        class="absolute z-10 w-full overflow-hidden mt-1 bg-white dark:bg-[#292929] rounded-xl shadow-lg border border-[#828282]">
                        <div class="">
                            <div *ngFor="let option of gradeDropdownOptions; let i = index"
                                (click)="selectGradeOption(option)"
                                class="px-3 py-2 hover:bg-gray-300 dark:text-textDark dark:hover:bg-gray-600 cursor-pointer flex items-center"
                                [ngClass]="{
                                    'rounded-t-xl': i === 0,
                                    'rounded-b-xl': i === gradeDropdownOptions.length - 1
                                  }">
                                <span class="flex-grow">{{ option }}</span>
                                <i
                                    class="fa-solid fa-hand-pointer ml-2 text-[#828282] opacity-0 group-hover:opacity-100"></i>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="relative min-w-0 custom-status-dropdown-container">
                    <!-- Hidden native select -->
                    <select [(ngModel)]="selectStatus" class="hidden" (change)="filterStatus()">
                        <option class="dark:bg-[#292929] text-textLight dark:text-textDark hover:bg-gray-300"
                            value="Pending">Pending</option>
                        <option class="dark:bg-[#292929] text-textLight dark:text-textDark hover:bg-gray-300"
                            value="Approved">Approved</option>
                        <option class="dark:bg-[#292929] text-textLight dark:text-textDark hover:bg-gray-300"
                            value="Rejected	">Rejected</option>
                    </select>

                    <!-- Custom dropdown trigger -->
                    <div class="border-[1.8px] border-[#828282] rounded-xl dark:bg-[#292929] text-textLight dark:text-textDark"
                        (click)="toggleStatusDropdown()">
                        <div class="flex flex-row justify-between items-center px-3 py-2 cursor-pointer ">
                            <span>{{ selectStatus || 'Status' }}</span>
                            <div class="flex items-center ">
                                <!-- X icon (shown ONLY when option is selected) -->
                                <i *ngIf="selectStatus" (click)="cancelStatus($event)"
                                    class="fa-solid fa-xmark text-lg text-[#828282] mr-2 hover:text-[#555] dark:hover:text-[#aaa] cursor-pointer"></i>

                                <!-- Arrow icon (shown when EITHER: dropdown is open OR no selection exists) -->
                                <i *ngIf="isStatusDropdownOpen || !selectStatus"
                                    class="fa-solid text-lg text-[#828282] transition-transform duration-200"
                                    [class.fa-angle-down]="!isStatusDropdownOpen"
                                    [class.fa-angle-up]="isStatusDropdownOpen"></i>
                            </div>
                        </div>
                    </div>

                    <!-- Custom dropdown options -->
                    <div *ngIf="isStatusDropdownOpen"
                        class="absolute z-10 w-full mt-1 overflow-hidden bg-white dark:bg-[#292929] rounded-xl shadow-lg border border-[#828282]">
                        <div class="">
                            <div *ngFor="let option of statusDropdownOptions; let i = index"
                                (click)="selectStatusOption(option)"
                                class="px-3 py-2 hover:bg-gray-300 dark:text-textDark dark:hover:bg-gray-600 cursor-pointer flex items-center"
                                [ngClass]="{
                                    'rounded-t-xl': i === 0,
                                    'rounded-b-xl': i === statusDropdownOptions.length - 1
                                  }">
                                <span class="flex-grow">{{ option }}</span>
                                <i
                                    class="fa-solid fa-hand-pointer ml-2 text-[#828282] opacity-0 group-hover:opacity-100"></i>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="[@container(max-width:760px)]:col-span-full [&_button]:shrink-0 flex items-center rounded-full px-4 py-2 min-w-0 bg-[#F1F1F1] dark:bg-[#292929]">
                    <input type="text" placeholder="Search by Crop / Variety name.." [(ngModel)]="searchText"
                        (keyup.enter)="onSearch()" (input)="trimmedSearchText()" (keyup.esc)="offSearch()"
                        class="bg-transparent outline-none w-full min-w-0 text-textLight dark:text-textDark" />
                    <button type="button" class="text-gray-500 hover:text-gray-700 focus:outline-none mr-2"
                        (click)="onSearch()">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                            stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M21 21l-6-6m2-5a7 7 0 10-14 0 7 7 0 0014 0z" />
                        </svg>
                    </button>
                    <button type="button" class="text-gray-500 hover:text-gray-700 focus:outline-none"
                        (click)="offSearch()">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                            stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>

            </div>

        </div>

        <div *ngIf="!hasData" class="flex flex-col items-center w-full h-screen px-10 py-7 mt-6 ">
            <p class="text-[#494949] my-6 dark:text-textDark">--No Data Availabale--</p>
            <img src="assets/images/NoData.png" alt="No Data" class="w-20 h-20" />
        </div>

        <div *ngIf="hasData" class="mt-5">
          <div class="isolate overflow-auto max-h-[max(410px,calc(100vh-360px))] border-gray-100 border-[2px] rounded-lg dark:border-[#202021]">
            <table class="w-full min-w-max divide-y-2">
                <thead class="sticky top-0 z-20 bg-white text-gray-700 dark:text-gray-300 dark:bg-[#0F0F0F] dark:border-[#202021] cursor-default">
                    <tr>
                        <th class="sticky left-0 bg-white dark:bg-[#0F0F0F] w-20 min-w-20 px-6 py-3 text-left font-medium dark:text-gray-300">No</th>
                        <th class="sticky left-20 bg-white dark:bg-[#0F0F0F] w-44 min-w-44 px-6 py-3 text-left font-medium dark:text-gray-300">Crop Name</th>
                        <th class="px-6 py-3 text-left font-medium dark:text-gray-300">Variety Name</th>
                        <th class="px-6 py-3 text-center font-medium dark:text-gray-300">Grade</th>
                        <th class="px-6 py-3 text-left font-medium dark:text-gray-300">Requested (Rs.)</th>
                        <th class="px-6 py-3 text-center font-medium dark:text-gray-300">Status</th>
                        <th class="px-6 py-3 text-left font-medium dark:text-gray-300">View</th>
                        <th class="px-6 py-3 text-left font-medium dark:text-gray-300">Centre Code</th>
                        <th class="px-6 py-3 text-left font-medium dark:text-gray-300">Centre Name</th>
                        <th class="px-6 py-3 text-left font-medium dark:text-gray-300">EMP ID</th>
                        <th class="px-6 py-3 text-left font-medium dark:text-gray-300">Time</th>
                    </tr>
                </thead>
                <tbody class="bg-white dark:bg-[#1D1D1F] dark:border-[#1D1D1F] cursor-default">
                    <tr *ngFor="let item of reqPriceArr | paginate: {
                itemsPerPage: itemsPerPage,
                currentPage: page,
                totalItems: totalItems
            }; let i = index">
                        <td class="sticky left-0 z-10 bg-white dark:bg-[#1D1D1F] px-6 py-4 text-gray-900 dark:text-gray-300">
                            {{ (((page - 1) * itemsPerPage) + i + 1) < 10 ? '0' + (((page - 1) * itemsPerPage) + i + 1)
                                : (((page - 1) * itemsPerPage) + i + 1) }} </td>
                        <td class="sticky left-20 z-10 bg-white dark:bg-[#1D1D1F] px-6 py-4 text-gray-900 dark:text-gray-300 break-words">{{item.cropNameEnglish}}</td>
                        <td class="px-6 py-4 text-gray-900 dark:text-gray-300">{{item.varietyNameEnglish}}</td>
                        <td class="px-6 py-4 text-gray-900 text-center dark:text-gray-300">{{item.grade}}</td>
                        <td class="px-6 py-4 text-gray-900 dark:text-gray-300">{{item.requestPrice | number:'1.2-2' }}
                        </td>
                        <td class="px-6 py-4 text-gray-900 dark:text-gray-300 flex justify-center items-center">
                            <span *ngIf="item.status === 'Pending'"
                                class="bg-[#F8FFA6] text-[#A8A100] text-center rounded-lg px-6 py-1 ">
                                Pending
                            </span>
                            <span *ngIf="item.status === 'Approved'"
                                class="bg-[#C8E0FF] text-[#415CFF] text-center rounded-lg px-4 py-1 ">
                                Approved
                            </span>
                            <span *ngIf="item.status === 'Rejected'"
                                class="bg-[#FFB9B7] text-[#D16D6A] text-center rounded-lg px-5 py-1 ">
                                Rejected
                            </span>
                        </td>
                        <td class="px-6 py-4 text-gray-900 dark:text-gray-300 text-center">
                            <button (click)="openPopUp(item.id, item.officerId)">
                                <svg width="25px" height="25px" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg" [attr.stroke]="'#415CFF'">
                                    <path
                                        d="M3 14C3 9.02944 7.02944 5 12 5C16.9706 5 21 9.02944 21 14M17 14C17 16.7614 14.7614 19 12 19C9.23858 19 7 16.7614 7 14C7 11.2386 9.23858 9 12 9C14.7614 9 17 11.2386 17 14Z"
                                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                </svg>
                            </button>
                        </td>
                        <td class="px-6 py-4 text-gray-900 dark:text-gray-300">{{item.regCode}}</td>
                        <td class="px-6 py-4 text-gray-900 dark:text-gray-300">{{item.centerName}}</td>
                        <td class="px-6 py-4 text-gray-900 dark:text-gray-300">
                            {{ item.empId }}
                        </td>
                        <td class="px-6 py-4 text-gray-900 dark:text-gray-300">{{item.createdAt | date: 'hh:mm a'}}</td>
                    </tr>
                </tbody>
            </table>
          </div>

            <div class="flex justify-end items-center my-5 pt-3 dark:bg-[#262f45] text-right">
                <pagination-controls (pageChange)="onPageChange($event)" [responsive]="true"
                    [previousLabel]="'Previous'" [nextLabel]="'Next'" [screenReaderPaginationLabel]="'Pagination'"
                    [screenReaderPageLabel]="'page'" [screenReaderCurrentLabel]="'Youre on page'">
                </pagination-controls>
            </div>
        </div>
    </div>
</div>
